export default __webpack_public_path__ + "0578011a2b9c2a7ac4e8a586fe9d604c.svg";